import { ChangeDetectorRef, Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import { DisplayContentData, GEDViewerComponent } from '../gedviewer/gedviewer.component';

const MAX_WIDTH = 80; // Représente la largeur que l'on veut donner au visualisateur de PDF dans l'iframe
const MAX_HEIGHT = 70;  // Représente la hauteur que l'on veut donner au visualisateur de PDF dans l'iframe

interface IframeDimensions {
  height: number;
  width: number;
}

@Component({
  selector: 'app-gedpdf-viewer',
  templateUrl: './gedpdf-viewer.component.html',
  styleUrls: ['./gedpdf-viewer.component.scss']
})
export class GEDPdfViewerComponent extends GEDViewerComponent {

  private _iframeDimensions: IframeDimensions = {
    height: 0,
    width: 0
  };

  urlDocument: SafeResourceUrl = this.domSanitizer.bypassSecurityTrustResourceUrl("about:blank");

  constructor(
    protected domSanitizer: DomSanitizer
  ) {
    super(domSanitizer);
    this.calcIframeDimensions();
  }

  public get iframeDimensions(): IframeDimensions {
    return this._iframeDimensions;
  }

  public set iframeDimensions(dimensions: IframeDimensions) {
    this._iframeDimensions = dimensions;
  }

  @HostListener('window:resize', ['$event'])
  public onResize(): void {
    this.calcIframeDimensions();
  }

  public calcIframeDimensions(): void {
    const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);

    this.iframeDimensions = {
      height: vh * MAX_HEIGHT / 100,
      width: vw * MAX_WIDTH / 100
    };
  }

  public async setData(data: DisplayContentData): Promise<void> {
    return new Promise<void>((resolve, _) => {
      setTimeout(async () => {
        let url = "";
        await fetch(data.data)
          .then(resp => resp.blob())
          .then(blob => {
            url = window.URL.createObjectURL(blob)
            this.urlDocument = this.sanitizeUrl(url);
          });
        this._data = data;

        setTimeout(async () => {
          const iframe = (document.querySelector(".iframegedviewer") as HTMLIFrameElement)
          if (iframe) {
            iframe.addEventListener('load', () => {
              // Utiliser un MutationObserver pour observer les changements dans le DOM
              const observer = new MutationObserver((mutationsList) => {
                for (let mutation of mutationsList) {
                  if (mutation.type === 'childList' && !document.body.contains(iframe)) {
                    window.URL.revokeObjectURL(url);
                    observer.disconnect(); // Arrête d'observer après avoir révoqué l'URL
                    break;
                  }
                }
              });

              observer.observe(document.body, { childList: true, subtree: true });

              resolve();
            });
          } else {
            resolve();
          }
        }, 0);
      }, 0);
    })
  }
}
